import React from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from "reactstrap";
import { types } from "mobx-state-tree";
import { observer } from "mobx-react-lite";
import "../../../components/codes/create/CreateCode.scss"

export const ModalState = types.model({
  open: types.maybe(types.boolean),
  title: types.maybe(types.string),
  eventUuid: types.maybe(types.string)
}).volatile(self => ({
})).actions( (self)=>({
  toggle(){
    self.open = !self.open
  },
  handleTitle(title){
    self.title = title
  },
  setEvent(e){
    const eventArr = e.target.value.split(" ")
    self.title = eventArr[0]
    self.eventUuid = eventArr[1]
  },
}))

const ScanbuyModal = observer(({modalStore,componentStore,EmbedComponent,size = "",className ="", currentState, onBeforeClose, headerActions}) => {
 const handleToggle = () => {
   if (onBeforeClose) {
     onBeforeClose();
   }
   modalStore.toggle();
 };

  return (
    <Modal
      isOpen={modalStore.open}
      toggle={handleToggle}
      centered
      size={size} //options include sm, lg, xl
      contentClassName={className}
      scrollable
    >
      <ModalHeader toggle={handleToggle}>
        <div className="d-flex align-items-center gap-2">
          {headerActions}
          {modalStore.title}
        </div>
      </ModalHeader>
      <ModalBody className="text-center m-3">
        <EmbedComponent store={componentStore} currentState={currentState}/>
      </ModalBody>
      {/*<ModalFooter>*/}
      {/*  <Button color="secondary" onClick={() => modalStore.toggle()}>*/}
      {/*    Close*/}
      {/*  </Button>{" "}*/}
      {/*  <Button*/}
      {/*    onClick={() => {*/}
      {/*      componentStore.saveAndClose(modalStore)*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    Save changes*/}
      {/*  </Button>*/}
      {/*</ModalFooter>*/}
    </Modal>
  );
})

export default ScanbuyModal;
